module.exports = __webpack_public_path__ + "static/media/trash.39b6b69a.svg";